import abeagle from './abeagle';

const testSlug = 'hp_front_cta_test';
const { edition, isFront, features } = window.HP.params;
const { adsFree } = features;
const isUS = edition === 'us';

if (isUS && isFront && !adsFree && window.HP.params.abeagle && Array.isArray(window.HP.params.abeagle) && window.HP.params.abeagle.includes(testSlug)) {
  document.addEventListener('abeagleEventCambria', () => {
    const variant = abeagle.getExperimentVariant(testSlug);
    const bodyElement = document.querySelector('body');
    if (variant) {
      bodyElement.classList.add(`ab-${testSlug}`);
      bodyElement.classList.add(`ab-${testSlug}--${variant}`);
    } else {
      bodyElement.classList.add(`ab-${testSlug}`);
      bodyElement.classList.add(`ab-${testSlug}--control`);
    }
  }, { once: true });
  window.HP.params.abFrontCtaTest.ready = true;
}
